<template>
  <div class="hs-form-grid" :class="[`hs-form-grid--${columns}`]">
    <slot />
  </div>
</template>

<script>
export default {
  name: "HsFormGrid",
  props: {
    columns: {
      type: String,
      default: "two",
      validator: (value) => ["one", "two", "three"].includes(value),
    },
  },
};
</script>

<style scoped>
.hs-form-grid {
  display: grid;
  gap: 1rem;
}

.hs-form-grid--one {
  grid-template-columns: 1fr;
}

.hs-form-grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.hs-form-grid--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 860px) {
  .hs-form-grid--two,
  .hs-form-grid--three {
    grid-template-columns: 1fr;
  }
}
</style>
